// Shared ledger-cell formatting: maps the backend subscription statuses
// (paid/partial/overdue/pending/no_row) to the prototype's `.cell` kind classes
// + glyphs, plus human labels. Used by both the chit ledger matrix and the
// subscriber-scoped chit view.

// status → prototype .cell kind class.
export const LEDGER_KIND: Record<string, string> = {
  paid: 'paid',
  partial: 'partial',
  overdue: 'unpaid',
  pending: 'due-now',
  no_row: 'upcoming',
};

// kind class → glyph.
export const LEDGER_GLYPH: Record<string, string> = {
  paid: '✓',
  partial: '½',
  unpaid: '✕',
  'due-now': '!',
  upcoming: '·',
};

export function ledger_status_label(status: string, lang: string): string {
  const map: Record<string, [string, string]> = {
    paid: ['முழுமையாக செலுத்தியது', 'Fully paid'],
    partial: ['பகுதியாக', 'Partial'],
    overdue: ['தாமதம்', 'Overdue'],
    pending: ['நிலுவை', 'Due'],
    no_row: ['இன்னும் உருவாக்கப்படவில்லை', 'Not generated yet'],
  };
  const pair = map[status];
  return pair ? (lang === 'ta' ? pair[0] : pair[1]) : status;
}

// 'YYYY-MM' → "Mon YYYY" for ledger column headers / month labels. Full
// 4-digit year for the year-crossover bug-of-perception — short "'25 / '26"
// kept making operators ask which year they were looking at.
export function ledger_month_label(due_month: string): string {
  const [y, m] = due_month.split('-');
  const names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const idx = Math.max(0, Math.min(11, Number(m) - 1));
  return `${names[idx]} ${y ?? ''}`;
}
